import { Component } from "react";
import ChatWrapper from "../../components/Chat/index";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { getAllUsers } from "../Layouts/Admin/Dentists/actions";
import {
    joinChatRoom,
    sendMessage,
    readMessage,
    eventOnJoin,
    eventOnMessage,
    eventOnLeave,
    eventOnRead,
    leaveChatRoom,
    getMessagesRequest,
    resetMessages,
    getNumberOfUnreadMessages,
    resetState,
    onNewUser,
} from "./actions";

class Chat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: [],
            onlineUsers: []
        };
        this.handleClickSend = this.handleClickSend.bind(this);
        this.handleClickConnect = this.handleClickConnect.bind(this);
        this.handleReadMessage = this.handleReadMessage.bind(this);
    }

    componentDidMount() {
        document.title = 'Messages';
        this.props.getAllDentists();
        this.props.eventOnJoin();
        this.props.eventOnMessage();
        this.props.eventOnRead();
        this.props.eventOnLeave();
        if(this.props.auth.currentUser.role === 'admin') {
            this.props.eventOnNewUser();
        }
    }

    handleClickConnect(id) {
        this.props.joinChatRoom(id);
    }

    handleClickSend(message, userId) {
        this.props.sendMessage({message, toUserId: userId});
    }

    handleReadMessage(messageId) {
        this.props.readMessage(messageId);
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {
        return <ChatWrapper getNumberOfUnreadMessages={this.props.getNumberOfUnreadMessages}
                            getMessages={this.props.getMessages}
                            handleReadMessage={this.handleReadMessage}
                            users={this.props.chatData.chatDentists}
                            handleClickConnect={this.handleClickConnect} 
                            onlineUsers={this.props.chatData.onlineUsers}
                            isSingleChat={false} 
                            currentUser={this.props.auth.currentUser}
                            sendMessage={this.handleClickSend} messages={this.props.chatData.messages}
                            adminIsOnline={this.props.chatData.adminIsOnline}
                            leaveChatRoom={this.props.leaveChatRoom}
                            joinChatRoom={this.props.joinChatRoom}
                            resetMessages={this.props.resetMessages}
                            numberOfMessages={this.props.chatData.numberOfMessages}
                            noMoreMessages={this.props.chatData.noMoreMessages}
                            loadingMessages={this.props.chatData.loadingMessages}
                            addedMessage={this.props.chatData.addedMessage}
                            eventOnNewUser={this.props.eventOnNewUser}
        />
    }
}

const mapStateToProps = state => {
    return ({
    auth: state.auth,
    chatData: state.chatData,
    chatReducer: state.chatReducer,
})};

const mapDispatchToProps = dispatch => {
    return {
        getAllDentists: () => dispatch(getAllUsers()),
        joinChatRoom: (userId) => dispatch(joinChatRoom(userId)),
        sendMessage: (data) => dispatch(sendMessage(data)),
        readMessage: (messageId) => dispatch(readMessage(messageId)),
        eventOnJoin: () => dispatch(eventOnJoin()),
        eventOnMessage: () => dispatch(eventOnMessage()),
        eventOnLeave: () => dispatch(eventOnLeave()),
        eventOnRead: () => dispatch(eventOnRead()),
        leaveChatRoom: () => dispatch(leaveChatRoom()),
        getMessages: (partnerId, page) => dispatch(getMessagesRequest(partnerId, page)),
        resetMessages: () => dispatch(resetMessages()),
        getNumberOfUnreadMessages: () => dispatch(getNumberOfUnreadMessages()),
        resetState: () => dispatch(resetState()),
        eventOnNewUser: () => dispatch(onNewUser()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Chat);



// WEBPACK FOOTER //
// ./src/containers/Chat/index.js